import {Avatar} from 'antd';
import {useAdminUsersQuery} from 'api/generated';
import gravatar from 'gravatar';
import initials from 'initials';
import React from 'react';

export const useAdminUsers = () => {
  const {data: adminUsersData} = useAdminUsersQuery();

  return adminUsersData?.adminUsers.items.map((user) => {
    const name = user.name ?? user.email;
    return {
      value: user.email,
      key: name,
      label: (
        <>
          <Avatar
            size="small"
            src={gravatar.url(user.email, {default: '404', s: '40'})}
            style={{marginRight: 8}}>
            {initials(name)}
          </Avatar>
          {name}
        </>
      ) as React.ReactNode
    };
  });
};
